import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';

function AddURLModal({ url, onClose, onSave }) {
  const [formData, setFormData] = useState({
    url: '',
    name: '',
    description: '',
    icon: ''
  });

  useEffect(() => {
    if (url) {
      setFormData({
        url: url.url || '',
        name: url.name || '',
        description: url.description || '',
        icon: url.icon || ''
      });
    }
  }, [url]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.url.trim()) {
      alert('URL is required');
      return;
    }
    onSave(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const modalContent = (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{url ? 'Edit URL' : 'Add New URL'}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="url">URL *</label>
            <input
              type="text"
              id="url"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="https://example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="name">Name (optional - will be fetched if empty)</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Website name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description (optional - will be fetched if empty)</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Website description"
              rows="3"
            />
          </div>
          <div className="form-group">
            <label htmlFor="icon">Icon URL (optional - will be fetched if empty)</label>
            <input
              type="text"
              id="icon"
              name="icon"
              value={formData.icon}
              onChange={handleChange}
              placeholder="https://example.com/favicon.ico"
            />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="save-button">
              {url ? 'Update' : 'Add'} URL
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default AddURLModal;

